<div class="container-box mobile">
  <div class="row">
    <div class="col-sm-12 col-md-10 col-md-offset-1">
      <h1>Contact us</h1>
      <div class="row">
        <div class="col-md-4 col-sm-12 contact-section" *ngIf="contactObj">
          <div class="img-section">
            <img src="assets/img/contact.png" alt="" aria-label="Contact" />
          </div>
          <div class="info-section">
            <p [innerHTML]="contactObj.contact_rep"></p>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 ticket-section" *ngIf="contactObj">
          <div class="img-section">
            <img src="assets/img/Ticket.png" alt="" aria-label="Ticket" />
          </div>
          <div class="info-section">
            <p [innerHTML]="contactObj.submit_ticket"></p>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 contact-section" *ngIf="contactObj">
          <div class="img-section">
            <img src="assets/img/call.png" alt="" aria-label="Contact" />
          </div>
          <div class="info-section">
            <p [innerHTML]="contactObj.phone_no"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>  
